/** Normalize ops API envelopes ({ success, data: { … } } vs flat payloads). */

export function unwrapOpsData(res) {
  if (!res || typeof res !== "object") return null;
  if (res.data != null && typeof res.data === "object" && !Array.isArray(res.data)) return res.data;
  return res;
}

export function pickOpsField(res, field, fallback = undefined) {
  const data = unwrapOpsData(res);
  if (data && data[field] != null) return data[field];
  if (res && res[field] != null) return res[field];
  return fallback;
}
